import { Button } from 'antd';
import { Flex, PageContainer } from '@/components';
import { useCartStore } from '@/store';
import CartListItems from './CartListItems';
import useBasketManagement from '@/hooks/app/useBasketManagement';
import { useTranslation } from 'react-i18next';
import { envConfig } from '@/configs';

export default function Cart() {

  const [t] = useTranslation();
  const basketItems = useCartStore(state => state.programs);
  const { loading, error, submit } = useBasketManagement();

  const getSumOfPrices = () => {
    let sum = 0;
    basketItems.map(x => sum = sum + (x.food!.price * x.selectedCount) || 0);
    return (sum / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  return (
    <PageContainer
      title={t('common:labels.cart')}
      displayFlex
    >
      <CartListItems />
      {basketItems.length > 0 &&
        <Flex className="mb-8" direction="column" justify="center">
          <span className="font-bold font-l text-center mt-4 text-nurture-darker">
            {`${t('common:labels.total-amount')}: ${getSumOfPrices()} ${envConfig.ui.removeCurrency ? '' : t('common:labels.tomans')}`}
          </span>
          {error !== '' && <p style={{ color: '#C7090C', textAlign: 'center' }}>{error}</p>}
          <Button
            size="large"
            loading={loading}
            disabled={loading}
            onClick={submit}
            className="w-full bg-green-600 text-white text-lg font-medium max-w-md mx-auto"
          >
            {t('common:labels.submit-pay')}
          </Button>
        </Flex>
      }
    </PageContainer>
  );
}
